import { render } from "./PrincipalMessageView.vue?vue&type=template&id=0eff7dc0"
import script from "./PrincipalMessageView.vue?vue&type=script&lang=js"
export * from "./PrincipalMessageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__